/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sreality_Password_HintInputs */

const cs_sreality_password_hint = /** @type {(inputs: Sreality_Password_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heslo importního účtu RK. Při dalších uloženích nechte prázdné, pokud ho neměníte.`)
};

const en_sreality_password_hint = /** @type {(inputs: Sreality_Password_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Password of the RK import account. Leave blank on later saves to keep the stored value.`)
};

/**
* | output |
* | --- |
* | "Password of the RK import account. Leave blank on later saves to keep the stored value." |
*
* @param {Sreality_Password_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sreality_password_hint = /** @type {((inputs?: Sreality_Password_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sreality_Password_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sreality_password_hint(inputs)
	return cs_sreality_password_hint(inputs)
});